const ENVIRONMENT = {
  API_URL: 'https://ruecker-api.foodbusiness.services/api',
  language: 'de',
  GOOGLE_API_KEY: 'AIzaSyDWGmZjlhY96H7AfoJ2yfLIXuNPmmQqDwk'
};
// Include local or production environment
let EXTERNAL_ENVIRONMENT = {}
try {
  const env = process.env.NODE_ENV === 'production' ? 'production' : 'local'
  EXTERNAL_ENVIRONMENT = require('./environment.' + env + '.ts')
  //later define production environment (env === 'production' ? EXTERNAL_ENVIRONMENT )
  EXTERNAL_ENVIRONMENT = EXTERNAL_ENVIRONMENT['default']
} catch (e) { /**/ }

export default {
  ...ENVIRONMENT,
  ...EXTERNAL_ENVIRONMENT
}
